//
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import AlertAndNotification from './AlertAndNotification.vue';
import { RouteNames } from '@/router/routeNames';

export default {
  path: '/alertAndNotifications',
  component: DashboardLayout,
  children: [
    {
      name: RouteNames.ALERT_AND_NOTIFICATIONS,
      path: '',
      component: AlertAndNotification,
    },
  ],
};
